export const Routes = {
    Root: '/',
    ContentImport: '/modules/import',
    ListModules: '/modules',
    ManageModule: '/modules/:moduleId',
    ManagePage: '/modules/:moduleId/:pageType/:pageId',
    ManageContent: '/modules/:moduleId/content/:pageId',
    ManageQuiz: '/modules/:moduleId/quiz/:pageId',
    ManageLive: '/modules/:moduleId/webinar/:pageId',
    ManageAdvertisement: '/modules/:moduleId/advertisement/:pageId',
    ManagePaidAdditionalModule: '/modules/extra-paid/new',
    ManageMentorshipModule: '/modules/mentorship/:mentorshipId',
    Tracks: '/tracks',
    MainModules: '/modules?extra=false',
    AdditionalModules: '/modules?extra=true'
};
